// extracted by mini-css-extract-plugin
module.exports = {"results":"results_results__2jLD1"};